import { Button, Modal, Form, Row, Col, message } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleUpdateFeedback } from "../../../api/distributions";
import { useEffect } from "react";
import TextArea from "antd/es/input/TextArea";

export default function UpdateFeedback({
  isVisible,
  setVisible,
  distribution,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isPending } = useMutation({
    mutationFn: handleUpdateFeedback,
    onSuccess: () => {
      message.success("Updated Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["distributions"] });
      setVisible(false);
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    const data = {
      ...values,
    };
    await mutate({ id: distribution?._id, data });
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.setFieldsValue({
      remarks: distribution?.remarks,})
  }, [distribution]);

  return (
    <Modal
      open={isVisible}
      title={`${distribution?.isCommented ? "Update" : "Add"} Remarks : ${distribution?.name}`}
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createFeedback"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createFeedback"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="feedback"
              label={"Feedback"}
              rules={[
                {
                  required: false,
                  message: "Please enter feedback",
                },
              ]}
            >
              <TextArea rows={4} placeholder="Feedback" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
